// CAROUSEL COMPONENT

import React from 'react'
import Carousel from 'react-bootstrap/Carousel'
import '../styles/carousel.css'

export default function IndexCarousel(props) {
    
    return(
    
        <div>
        
            {/*<div class={props.carouselClass}>*/}  
                            
                <Carousel>
                                
                    {props.data.map((carousel_content) => 

                        <Carousel.Item>
                            <img loading="lazy" className={props.styles} src={carousel_content.background_image} alt=" Home Page featured content" />
                            <Carousel.Caption class="carousel-caption">
                                <h2 class="captionHeader"><a href={carousel_content.url} id="carouselLink">{carousel_content.caption}</a></h2>
                            </Carousel.Caption>
                        </Carousel.Item>
                                        
                     )}
                    
                </Carousel>
                        
            {/*</div>*/}
    
        </div>
    
    )
    
}
